import styled from 'styled-components';

import { breakpoints, colors, fontFamily, zIndex } from '../../ui/variables';

import { headerVariables } from '../../components/Header/HeaderStyle';

export const InstitutionsArchiveStyle = styled.main`
  padding-top: ${headerVariables.main.height.iphone}px;
  padding-left: 4%;

  @media (min-width: ${breakpoints.hd.width}px) {
    padding-right: 20%;
  }

  @media (min-width: 1370px) {
    padding-right: 211px;
    padding-left: 88px;
  }

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone}px;
    }
  }

  .header-institutions-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 73px;
    margin-bottom: 35px;
    padding-left: 20px;

    @media (min-width: 1370px) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .title-header {
      ${fontFamily.sourceSansPro.bold}
      font-size: 24px;
      margin-bottom: 10px;

      .number-of-registers {
        display: none;
        @media (min-width: 1370px) {
          display: inline-block;
          ${fontFamily.sourceSansPro.regular}
          font-size: 14px;
        }

        .score {
          ${fontFamily.sourceSansPro.bold}
          font-size: 14px;
          margin-left: 20px;
        }
      }
    }
    .button-wrapper {
      margin-right: 10px;
      width: 219px;
      height: 45px;
    }
  }

  .search-institution-form {
    display: flex;
    flex-direction: column;

    /* @media (min-width: 1370px) {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    } */
    .search-input-container {
      width: 100%;
    }

    .filters {
      display: flex;
      flex-direction: column;

      /* @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        flex-direction: row;
      } */
      /* display: flex;
      flex-direction: row;
      align-items: center; */
      width: 100%;
      position: relative;

      .select-wrapper {
        width: 85%;
        min-width: 50%;
        display: flex;
        flex-direction: column;
      }

      .select-button {
        margin-top: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .slider {
        position: relative;
        margin-left: 2%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 48px;
        width: 120px;
        min-width: 120px;
        border: 1px solid #eef2ff;
        border-radius: 19px;

        .list-icon-wrapper {
          display: flex;
          align-items: center;
          height: 12px;
          width: 20px;
          svg {
            fill: ${colors.grayishBlue};
            transition: fill 500ms;
          }

          &.selected {
            svg {
              fill: white;
            }
          }
        }

        .gallery-icon-wrapper {
          display: flex;
          align-items: center;
          height: 20px;
          width: 20px;
          svg {
            fill: ${colors.grayishBlue};
            transition: fill 500ms;
          }

          &.selected {
            svg {
              fill: white;
            }
          }
        }

        min-width: 70px;

        .slider-button {
          background-color: ${colors.softBlue};
          width: 50%;
          height: 100%;
          position: absolute;
          border-radius: 19px;
          left: 0;
          ${zIndex.underground};

          transition: left 300ms;

          &.right {
            left: 50%;
          }
          .text {
            display: none;
          }
        }
      }

      .approve-results-button {
        margin-top: 15px;

        .button-element {
          width: auto;
        }
      }
    }
  }

  .institution-list-pagination-wrapper {
    margin-top: 20px;
    margin-bottom: 40px;
  }
`;
